import { Pagination, PaginationProps } from "antd";
import Link from "next/link";
import { NextRouter, useRouter } from "next/router";

function createItemRender(router: NextRouter) {
  const itemRender: PaginationProps["itemRender"] = (
    current,
    type,
    originalElement
  ) => {
    return (
      <Link
        href={{
          pathname: router.pathname,
          query: {
            ...router.query,
            current,
          },
        }}
      >
        {originalElement}
      </Link>
    );
  };
  return itemRender;
}

export const LinkPagination = (props: PaginationProps) => {
  const router = useRouter();
  return (
    <Pagination
      onChange={() => {}}
      {...props}
      itemRender={createItemRender(router)}
    />
  );
};
